import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Modal from 'components/modal/modal'
import { Col, ModalBody, Row } from 'react-bootstrap'
import { InfoButton } from 'components/buttons'
import Link from 'components/link'
import Input from 'components/forms/input'
import Form from 'components/forms/form'
import DateSelect from 'components/date-select'
import { registerForPampers } from '../../actions'
import { reduxForm } from 'redux-form'
import {
  createValidator,
  dateString,
  email,
  isPresent,
  required,
} from 'lib/form-validation'
import Image from 'components/image'

class PampersRegistrationModal extends React.Component {
  static propTypes = {
    user: PropTypes.shape({
      firstName: PropTypes.string,
      email: PropTypes.string,
    }).isRequired,
    registry: PropTypes.shape({
      family: PropTypes.shape({
        arrivalDate: PropTypes.string,
      }).isRequired,
    }).isRequired,
    registerForPampers: PropTypes.func.isRequired,
  }

  state = {}

  handleSubmit = (fields) => {
    this.setState({ submitting: true })
    const { password, ...user } = fields
    this.props
      .registerForPampers({ user, password })
      .then(this.props.onHide)
      .catch(() => this.setState({ submitting: false, isError: true }))
  }

  render() {
    const { show, onHide } = this.props

    return (
      <Modal show={show} onHide={onHide} title="Join Pampers Club" size="large">
        <ModalBody>
          <PampersRegistrationReduxForm
            onSubmit={this.handleSubmit}
            submitting={this.state.submitting}
            isError={this.state.isError}
            user={this.props.user}
            registry={this.props.registry}
          />
        </ModalBody>
      </Modal>
    )
  }
}

const PampersRegistrationForm = ({
  handleSubmit,
  isError,
  fields: { arrivalDate, firstName, email, password },
}) => (
  <Form
    error={isError ? <PampersRegistrationErrorMessage /> : null}
    onSubmit={handleSubmit}
  >
    <Row className="mtl">
      <Col sm={6}>
        <Image
          src="https://res.cloudinary.com/babylist/image/upload/q_auto,f_auto/v1539714676/partner/pampers-promo_2x.png"
          className="center-block mbm"
          alt="Pampers Club promotion"
          height="619"
          width="254"
        />
      </Col>

      <Col sm={6}>
        <div className="h4 mtn text-bold">
          Join for a chance to win 1 year supply of Pampers diapers!*
        </div>
        <Input
          label="First Name"
          {...firstName}
          error={firstName.touched ? firstName.error : null}
        />
        <DateSelect
          label="Arrival Date"
          {...arrivalDate}
          error={arrivalDate.touched ? arrivalDate.error : null}
        />
        <Input
          label="Email"
          type="email"
          {...email}
          error={email.touched ? email.error : null}
        />
        <Input
          label="Password for Pampers Club"
          type="password"
          {...password}
          error={password.touched ? password.error : null}
        />

        <div className="mbl">
          <em className="h7 lh-large">
            By registering, I agree to receive emails from Pampers and other
            trusted{' '}
            <Link
              url="http://us.pg.com/our-brands"
              rel="nofollow noindex"
              newWindow
            >
              P&G brands
            </Link>{' '}
            and programs. Click to read{' '}
            <Link
              rel="nofollow noindex"
              url="http://www.pg.com/en_US/terms_conditions/index.shtml"
              newWindow
            >
              P&G Terms and Conditions
            </Link>{' '}
            and{' '}
            <Link
              rel="nofollow noindex"
              url="http://www.pg.com/privacy/english/privacy_notice.shtml"
              newWindow
            >
              P&G Privacy Policy
            </Link>
            . *One winner is chosen every month.{' '}
            <Link
              rel="nofollow noindex"
              url="http://pamperssweepsrules.dja.com/"
              newWindow
            >
              Official Rules
            </Link>
            .
          </em>
        </div>

        <InfoButton block type="submit">
          Create your account
        </InfoButton>
      </Col>
    </Row>
  </Form>
)

const PampersRegistrationErrorMessage = () => (
  <span>
    Sorry, something went wrong and we were unable to create a Pampers Club
    account for you. Please try again or visit{' '}
    <Link
      url="https://www.pampers.com/en-us/registration?utm_source=Babylist&utm_medium=partner&utm_campaign=Gift%20Reservations"
      rel="nofollow noindex"
      newWindow
    >
      Pampers Club
    </Link>{' '}
    directly.
  </span>
)

const pampersPasswordValidator = (value) => {
  if (
    isPresent(value) &&
    (value.length < 8 || !value.match(/\d/) || !value.match(/[a-zA-Z]/))
  ) {
    return `The password must be minimum 8 characters, including at least 1 letter and 1 number.`
  }
}

const PampersRegistrationReduxForm = reduxForm(
  {
    form: 'pampersRegistrationForm',
    fields: ['firstName', 'arrivalDate', 'email', 'password'],
    validate: createValidator({
      firstName: [required],
      arrivalDate: [required, dateString],
      email: [required, email],
      password: [pampersPasswordValidator],
    }),
  },
  (state, props) => ({
    initialValues: {
      firstName: props.user.firstName,
      email: props.user.email,
      arrivalDate: props.registry.family && props.registry.family.arrivalDate,
    },
  })
)(PampersRegistrationForm)

export default connect(undefined, { registerForPampers })(
  PampersRegistrationModal
)
